export function initLinksResume(){
    const container = document.querySelector(".form-link-items") as HTMLElement | null;
    const addBtn = document.querySelector(".form-link .button-border-black") as HTMLButtonElement | null;

    if (container && addBtn) {
        addBtn.addEventListener("click", () => {
            const formItem = container.querySelector(".form-item") as HTMLElement | null;
            console.log(formItem)
            if (!formItem) return;

            // Клонируем блок
            const clone = formItem.cloneNode(true) as HTMLElement;

            // Очищаем input
            const input = clone.querySelector("input") as HTMLInputElement | null;
            if (input) {
                input.value = "";
                // Генерируем уникальный id, чтобы label работал корректно
                const newId = "input-link-" + Date.now();
                input.id = newId;

                const label = clone.querySelector("label") as HTMLLabelElement | null;
                if (label) {
                    label.setAttribute("for", newId);
                }
            }

            if (!clone.querySelector(".link-delete")) {
                const deleteBtn = document.createElement("button");
                deleteBtn.className = "link-delete icon";
                deleteBtn.innerHTML = `
                    <svg><use xlink:href="images/sprite.svg#icon-Delete"></use></svg>
                `;
                deleteBtn.addEventListener("click", () => {
                    clone.remove();
                });

                clone.appendChild(deleteBtn);
            }

            container.appendChild(clone);
        });
    }
}